export default __webpack_public_path__ + "static/media/gallery-wip-handle_07.1f6ede16.jpg";